import { useState, useEffect } from "react";
import Alert from './alert.js';

export default function Alerts(props) {
  
  const [points, setpoints] = useState([]);

  function changeKind(event) {
    props.changeKind(event.target.value);
  }

  function sortPoints() {
    function diff(a,b) {
      if (a===b) return 0
      else if (a==null) return 1
      else if (b==null) return -1
      else return a < b ? 1 : -1; 
    }

    if (props.kind.name==="気温") {
      points.sort((a, b) => diff(a.temp.value, b.temp.value));
    } if (props.kind.name==="湿度") {
      points.sort((a, b) => diff(a.humi.value, b.humi.value));
    } if (props.kind.name==="風速") {
      points.sort((a, b) => diff(a.wind.value, b.wind.value));
    } if (props.kind.name==="雨量") {
      points.sort((a, b) => diff(a.rain.value, b.rain.value));
    } if (props.kind.name==="震度") {
      points.sort((a, b) => diff(a.seis.value, b.seis.value));
    } if (props.kind.name==="雷") {
      points.sort((a, b) => diff(a.thunder.value, b.thunder.value));
    }
  }

  useEffect(() => {
    if (props.points.length > 0) {
      setpoints(props.points);
      sortPoints();
    }
  }, [props.kind,props.points]);

  sortPoints();

  return (
    <div style={{ fontSize: "clamp(0.5em, 1vw, 1em)", maxWidth: "220px"}}>
      <div className="tab-area">
      <input type="radio" name="tab-radio" className="tab-radio" id="tab01" value="気温" checked={"気温" === props.kind.name} onChange={changeKind}/>
      <label htmlFor="tab01" className="tab-menu" id="tabMenu01">気温</label>
      <input type="radio" name="tab-radio" className="tab-radio" id="tab02" value="湿度" checked={"湿度" === props.kind.name} onChange={changeKind}/>
      <label htmlFor="tab02" className="tab-menu" id="tabMenu02">湿度</label>
      <input type="radio" name="tab-radio" className="tab-radio" id="tab03" value="雨量" checked={"雨量" === props.kind.name} onChange={changeKind}/>
      <label htmlFor="tab03" className="tab-menu" id="tabMenu03">雨量</label>
      <input type="radio" name="tab-radio" className="tab-radio" id="tab04" value="風速" checked={"風速" === props.kind.name} onChange={changeKind}/>
      <label htmlFor="tab04" className="tab-menu" id="tabMenu04">風速</label>
{/*
      <input type="radio" name="tab-radio" className="tab-radio" id="tab04" value="雷" checked={"雷" === props.kind.name} onChange={changeKind}/>
      <label htmlFor="tab04" className="tab-menu" id="tabMenu04">雷</label>
*/}
      <input type="radio" name="tab-radio" className="tab-radio" id="tab05" value="震度" checked={"震度" === props.kind.name} onChange={changeKind}/>
      <label htmlFor="tab05" className="tab-menu" id="tabMenu05">震度</label>
      </div>
      <div style={{ clear:"both", overflowY: "auto",	overflowX: "hidden", height: "calc(100vh - 128px)"}}>
      {
        points.map((point,idx) => (
          <Alert key={idx} onSelect={props.onSelect} onMove={props.onMove}
            unit={props.kind.unit}
            name={point.name}
            value={point.selected.display}
            color={point.selected.color}
            fontcolor={point.selected.fontcolor}
            onOpenSite={props.onOpenSite}
          />
         ))
      }
      </div>
    </div>
  )
};